module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/243-canada-cab0f9b8e2b28f1d3cf819b35503cdde.svg";